export class FrtShipmentsAccessorials {
   public shipmentAccrlsId: number;
   public shipmentsId: number;
   public frtAccessorialsId: number;
   public quantity: number = 0;
   public requestor: string = "Shipper";
   public usage: string;
   public shipperRequest: string;
   public tspRequest: string = "None";
   public accessorialCost: number = 0;
  


}